var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderPackingDetail',{attrs:{"label":"Cashbill","with-fee":false,"index-path":"/gudang/pengeluaran"}})
}
var staticRenderFns = []

export { render, staticRenderFns }